































































import { Component, InjectReactive, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { FeedCorrection, FeedTank, FeedTypeLevelMetricEnum } from '@/api';
import { FeedTankService } from '@/pages/account/products/feed/services';
import Toast from '@/components/display/toast.vue';
import { CorrectionService } from '@/services/correction-service';
import { CustomFormulaResult, Millimeters } from '@/typings/custom-formula-calculator';

@Component({
	components: {},
})
export default class FeedTankCorrectionsList extends Vue {
	public correctionFields: { key: string; label: string }[] = [];

	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;

	@Prop()
	public parameters!: Record<string, string | number>;

	@PropSync('savedCorrections')
	public _savedCorrections!: FeedCorrection[];

	@Prop()
	public correction: any | null;

	public deletingCorrections: boolean = false;
	public selectedCorrections: any[] = [];

	private feedTankService: FeedTankService | null = null;
	private toast = new Toast();

	@Watch('feedTank')
	public async created() {
		this.correctionFields = [
			{ key: 'sel', label: '' },
			{ key: 'eventTimestamp', label: 'Date' },
			{ key: 'correctionType', label: 'Type' },
			this.isTonnes()
				? { key: 'originalWeight', label: 'Levno Weight' }
				: { key: 'originalVolume', label: 'Levno Volume' },
			this.isTonnes()
				? { key: 'weight', label: 'Correct Weight' }
				: { key: 'volume', label: 'Correct Volume' },
			{ key: 'newVolume', label: `New ${this.isTonnes() ? 'Weight' : 'Volume'}` },
			{ key: 'diff', label: 'Correction Difference' },
			{ key: 'notes', label: 'Notes' },
			{ key: 'user.name', label: 'By' },
		];

		this.feedTankService = new FeedTankService(this.feedTank);
		await this.loadCorrections();
	}

	public async loadCorrections(callApi: boolean = true): Promise<void> {
		let data: FeedCorrection[] = this._savedCorrections ?? [];
		if (callApi) {
			const correctionsResult = await this.feedTankService?.getCorrections(this.feedTank);
			if (correctionsResult?.errorMessage) {
				console.error(correctionsResult.errorMessage);
				return;
			}
			data = correctionsResult?.data ?? [];
		}
		const corrections = [];
		for (const i in data) {
			const correction = data[i];
			if (!correction) continue;
			switch (correction.correctionType) {
				case 'refill':
					const temp: {
						result: CustomFormulaResult | Error | null;
						error?: string;
					} = await CorrectionService.calculateFeedTankVolume(
						[<Millimeters>correction?.startReading ?? 9999],
						correction?.additionalParameters?.start ?? {},
						this.feedTank,
						this.parameters,
						this.correction,
					);
					const temp2: {
						result: CustomFormulaResult | Error | null;
						error?: string;
					} = await CorrectionService.calculateFeedTankVolume(
						[<Millimeters>correction?.endReading ?? 9999],
						correction?.additionalParameters?.end ?? {},
						this.feedTank,
						this.parameters,
						this.correction,
					);
					if (temp.error || temp2.error)
						console.error(temp.error ?? temp2.error ?? 'Error calculating correction');
					else
						correction.newVolume =
							((<CustomFormulaResult>temp2.result)?.volume -
								(<CustomFormulaResult>temp.result)?.volume) *
							(this.feedTank.feedtype?.density ?? 1);
					break;
			}
			corrections.push(correction);
		}
		this._savedCorrections = corrections;
	}

	public unit(value?: number) {
		return !value
			? ''
			: this.isTonnes()
			? this.$options.filters?.tonnes(value)
			: this.$options.filters?.numeric(value) + ' L';
	}

	public isTonnes() {
		return this.feedTank.feedtype?.levelMetric == FeedTypeLevelMetricEnum.Weight;
	}

	public async deleteCorrections(): Promise<void> {
		this.deletingCorrections = true;
		let errored = false;
		for (const i in this.selectedCorrections) {
			const { error } = await CorrectionService.deleteCorrection(
				+this.feedTank.id!,
				+this.selectedCorrections[i].id!,
			);
			if (error != null) {
				this.toast.makeToast(error, 'Error', 'danger');
				errored = true;
			}
		}

		this._savedCorrections = this._savedCorrections.filter(
			correction => this.selectedCorrections.map(c => c.id).indexOf(correction.id) === -1,
		);
		this.selectedCorrections = [];

		if (!errored)
			this.toast.makeToast('Successfully deleted all selected corrections', 'Success', 'success');
		this.deletingCorrections = false;
	}
}
